import * as yup from 'yup'
import { defineMessages } from 'react-intl'

const companyMessages = defineMessages({
  required: {
    id: 'campaigns.form.company.required',
    defaultMessage: 'The company is required'
  }
})

const nameMessages = defineMessages({
  required: {
    id: 'campaigns.form.name.required',
    defaultMessage: 'The name is required'
  },
  max: {
    id: 'campaigns.form.name.max',
    defaultMessage: 'The name can be up to 255 characters'
  }
})

const areaMessages = defineMessages({
  required: {
    id: 'campaigns.form.area.required',
    defaultMessage: 'The area is required'
  }
})

const typeMessages = defineMessages({
  required: {
    id: 'campaigns.form.type.required',
    defaultMessage: 'The type is required'
  }
})

const startsAtMessages = defineMessages({
  required: {
    id: 'campaigns.form.startsAt.required',
    defaultMessage: 'The starting date is required'
  }
})

const endsAtMessages = defineMessages({
  required: {
    id: 'campaigns.form.endsAt.required',
    defaultMessage: 'The ending date is required'
  }
})

const timezoneMessages = defineMessages({
  required: {
    id: 'campaigns.form.timezone.required',
    defaultMessage: 'The timezone is required'
  }
})

const descriptionMessages = defineMessages({
  required: {
    id: 'campaigns.form.description.required',
    defaultMessage: 'The description is required'
  }
})

export const schema = (intl: TSFixMe): TSFixMe => {
  return yup.object().shape({
    company: yup.object().shape({
      id: yup.string().required(intl.formatMessage(companyMessages.required))
    }),
    name: yup
      .string()
      .required(intl.formatMessage(nameMessages.required))
      .max(255, intl.formatMessage(nameMessages.max)),
    area: yup.string().required(intl.formatMessage(areaMessages.required)),
    type: yup.string().required(intl.formatMessage(typeMessages.required)),
    startsAt: yup.string().required(intl.formatMessage(startsAtMessages.required)),
    endsAt: yup.string().required(intl.formatMessage(endsAtMessages.required)),
    timezone: yup.string().required(intl.formatMessage(timezoneMessages.required)),
    description: yup.string().required(intl.formatMessage(descriptionMessages.required))
  })
}
